import { P } from "@/shared/ui/typographies/paragraph";

type InlineErrorBannerProps = { message: string };

export const InlineErrorBanner = ({ message }: InlineErrorBannerProps) => (
  <div className="rounded-lg border border-red-200 bg-red-50 p-3 dark:border-red-800 dark:bg-red-950/30" aria-live="polite">
    <P size="sm" className="text-red-700 dark:text-red-300">{message}</P>
  </div>
);
